import { Box } from '@mui/material';

import { MarketCardSkeleton } from '@/components/skeletons/common';

interface BookmarkSkeletonListProps {
  count?: number;
}

export function BookmarkSkeletonList({ count = 6 }: BookmarkSkeletonListProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(1, minmax(0, 1fr))',
          sm: 'repeat(2, minmax(0, 1fr))',
          md: 'repeat(3, minmax(0, 1fr))',
          lg: 'repeat(4, minmax(0, 1fr))',
        },
        gap: 1.5,
        width: '100%',
      }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <MarketCardSkeleton key={i} />
      ))}
    </Box>
  );
}
